import ApplicationSerializer from 'cio/serializers/application';
import { ModelSchema } from 'ember-data';
import { ModelRegistry } from 'ember-data/model';

export default class SetupGuideSerializer extends ApplicationSerializer {
  normalize(type: ModelSchema<keyof ModelRegistry>, hash: Record<string, unknown>, prop: string) {
    // Setup guides don't have an ID, so we add one.
    hash.id = 'current';
    return super.normalize(type, hash, prop);
  }
}
